





















































import { NdSklad } from '@/modules/sklad/ndSklad';
import { NdCenik } from '@/modules/sklad/ndCenik';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { Zakazka } from '@/modules/servis/zakazka';
import { Ozakazka } from '@/modules/servis/ozakazka';
import { editFactory } from '@/main/pages';
import { openList } from '@/main/router/routerPath';
import { cellNames, Table } from '@/main/utils/table';
import { apiProvider as ndCenikProvider } from '@/modules/sklad/ndCenik/api';

import { editMutations } from './store/types';
import { NAME } from './constants';
import { store } from './store/edit';
import { apiProvider as ndSkladApiProvider } from '../ndSklad/api';

type NdSkladFilter = {
	VyrobekndOzn: string | null;
	NdNr: string | null;
	SkladOzn: number | null;
	NdText: string | null;
	EanCode: string | null;
};

export default editFactory(NAME, store).extend({
	components: {
		SkladMistoSelect: SkladMisto.components.Select,
		ZakazkaSelect: Zakazka.components.Select,
		OzakazkaSelect: Ozakazka.components.Select,
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
	},
	data() {
		return {
			vyrobekNdChanged: false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakazka: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_ZAKAZKA_SELECT_MAPPER}`,
				ozakazka: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_OZAKAZKA_SELECT_MAPPER}`,
				sklad: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_SKLAD_SELECT_MAPPER}`,
				ndSklad: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_ND_SKLAD_SELECT_MAPPER}`,
			};
		},
		isDisabledKontrolaNd(): boolean {
			return this.isNdNrChosen || this.isNdNrDisabled;
		},
		isMnostviDisabled(): boolean {
			return !!(!this.isCreateMode && this.MnozstviDodano);
		},
		isMioPznDisabled(): boolean {
			return !this.isCreateMode || (this.props.filter ? !!this.props.filter.MioPzn : false);
		},
		isNdNrDisabled(): boolean {
			return !this.isCreateMode || (this.props.filter ? !!this.props.filter.NdNr : false);
		},
		mnozstviZbyva(): number {
			return Math.max(0, this.MnozstviObj! - this.MnozstviDodano!);
		},
		skladFilter(): { SkladOzn: number | null, VyrazenPrp: boolean | null } {
			return {
				SkladOzn: this.SkladOzn,
				VyrazenPrp: this.VyrazenPrp,
			};
		},
		ndskladFilter(): NdSkladFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				NdText: this.Text,
				EanCode: this.EanCode,
			};
		},
	},
	methods: {
		loadedData() {
			if (this.props.filter?.Kontrola) {
				this.onKontrolaNdClick();
			}
		},
		onVyrobekNdUpdate() {
			if (this.isNdNrChosen) {
				this.Text = null;
				this.EanCode = null;
				this.NdNr = null;
				this.isNdNrChosen = false;
			}
		},
		async onKontrolaNdClick() {
			if (this.SkladOzn === -1) {
				openList(NdCenik.name, { filter: this.ndskladFilter });
			} else {
				try {
					this.startLoading();
					const { data: rows } = await NdSklad.apiProvider.tableDataSelect({ ...this.ndskladFilter, HledejPodretezecNdNr: true });
					if (rows.length === 1) {
						const table = new Table({ rows });
						const ndSkladId = table.rows[0].cells[cellNames(table).idColumn];
						const { data: rowData } = await ndSkladApiProvider.entity(ndSkladId);
						const mappedData = {
							value: rowData.ZaznamId,
							text: rowData.Text,
							ndnr: rowData.NdNr,
							cenasdph: rowData.NcGd,
							vydejmjid: rowData.VydejMjId,
							vyrobekndozn: rowData.VyrobekndOzn,
						};
						this.$store.commit(this.mutationsMappers.ndSklad, { data: mappedData });
					} else {
						const resp = await ndCenikProvider.entityByKey({
							vyrobekndOzn: this.VyrobekndOzn,
							ndNr: this.NdNr,
						});
						if (resp.data) {
							this.kontrolaCenik(resp);
						}
					}
				} finally {
					this.endLoading();
				}
			}
			return false;
		},
		onNdNrInputUpdate(val: string | null) {
			this.NdNr = val;
			if (this.isNdNrChosen) {
				this.Text = null;
				this.EanCode = null;
				this.isNdNrChosen = false;
			}
		},
	},
});
